import axios from 'axios'
import { HttpResponse } from 'aws-sdk'

var http = axios.create({
  baseURL: process.env.API_BASE_URL + '/promotion',
  headers: {'Content-Type': 'application/json'}
})

http.interceptors.response.use(function (response) {
  return response
}, function (error) {
  if (error.response.status !== 401) return Promise.reject(error)

  var refreshAndRetry = new Promise(function (resolve) {
    axios.post(process.env.API_BASE_URL + '/account/refresh_token',
      {
        'refresh_token': JSON.parse(localStorage.getItem('refresh_token')).value
      },
      {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + JSON.parse(localStorage.getItem('token')).value
        }
      }).then(function (response) {
      localStorage.setItem('refresh_token', JSON.stringify({
        value: response.data.refresh_token,
        expire: null
      }))

      localStorage.setItem('token', JSON.stringify({
        value: response.data.token,
        expire: null
      }))

      return Promise.resolve(response)
    }).then(function (response) {
      var failedRequest = error.config
      failedRequest.headers.Authorization = 'Bearer ' + JSON.parse(localStorage.getItem('token')).value
      axios.request(failedRequest).then(function (retryResponse) {
        resolve(retryResponse)
      })
    })
  })

  return refreshAndRetry
})

function getConfig () {
  return {
    headers: {
      'Authorization': JSON.parse(localStorage.getItem('token')).value
    }
  }
}

function getListMataPelajaran (callback) {
  var config = getConfig()
  http.get('/mapels', config).then(function (response) {
    callback({
      success: true,
      data: response.data
    })
  }).catch(function (error) {
    callback({
      success: false,
      message: error.message
    })
  })
}

function getItemsByMataPelajaran (params, callback) {
  var config = getConfig()
  var code = ''
  var label = ''
  var babName = ''
  var subbabName = ''
  var subsubabName = ''
  var jenjang = ''
  var jenis = ''
  var kelas = ''
  if(params.itemCode !== '') code ='&item_code=' + params.itemCode
  if(params.label !== '') label ='&label=' + params.label
  if(params.babName !== '') babName ='&bab=' + params.babName
  if(params.subbabName !== '') subbabName ='&subbab=' + params.subbabName
  if(params.subsubabName !== '') subsubabName ='&subsubbab=' + params.subsubabName
  if(params.jenjang !== '') jenjang ='&jenjang=' + params.jenjang
  if(params.jenis !== '') jenis ='&jenis=' + params.jenis
  if(params.kelas !== '') kelas ='&grade=' + params.kelas

  http.get('/items?mapel_id=' + params.mapelId + code + label + babName + subbabName + subsubabName + jenjang + jenis + kelas + '&page='+ params.page, config)
    .then(function (response) {
      callback({
        success: true,
        data: response.data
      })
    }).catch(function (error) {
      callback({
        success: false,
        message: error.message
      })
    })
}

function getListOfSchoolGrade (callback) {
  var config = getConfig()
  http.get('/grades', config)
    .then(function (response) {
      callback({
        success: true,
        data: response.data
      })
    }).catch(function (error) {
      callback({
        success: false,
        message: error.message
      })
    })
}

function getListOfTopicGrade (callback) {
  var config = getConfig()
  http.get('/topic_grades', config).then(function (response) {
    callback({
      success: true,
      data: response.data
    })
  }).catch(function (error) {
    callback({
      success: false,
      message: error.message
    })
  })
}

function getListOfItemType (callback) {
  var config = getConfig()
  http.get('/types', config)
    .then(function (response) {
      callback({
        success: true,
        data: response.data
      })
    }).catch(function (error) {
      callback({
        success: false,
        message: error.message
      })
    })
}

function getListOfTopic (mapelCode, callback) {
  var config = getConfig()
  http.get('/topics?mapel_code=' + mapelCode, config)
    .then(function (response) {
      callback({
        success: true,
        data: response.data
      })
    }).catch(function (error) {
      callback({
        success: false,
        message: error.message
      })
    })
}

function createItem (data, callback) {
  var config = getConfig()
  var postData = {
    wacana: data.wacana,
    isi: data.soal,
    pilihan_1: data.opsiA,
    pilihan_2: data.opsiB,
    pilihan_3: data.opsiC,
    pilihan_4: data.opsiD,
    pilihan_5: data.opsiE,
    jawaban: data.jawaban,
    pembahasan: data.pembahasan,
    mapel_id: data.mapelId,
    // jenjang_id: data.jenjang,
    // jenis_soal_id: data.jenis,
    // bab_id: data.babId,
    // sub_bab_id: data.subBabId,
    // sub_sub_bab_id: data.subSubBabId,
    // sumber: data.sumber,
    // pembahasan: data.pembahasan,
    // is_restricted: data.is_restricted,
    // label: data.label,
    arr_grades: data.grades
  }

  http.post('/item', postData, config)
    .then(function (response) {
      callback({
        success: true,
        data: null
      })
    }).catch(function (error) {
      callback({
        success: false,
        message: error.message
      })
    })
}

function updateItem (id, data, callback) {
  var config = getConfig()
  var postData = {
    wacana: data.wacana,
    isi: data.soal,
    pilihan_1: data.opsiA,
    pilihan_2: data.opsiB,
    pilihan_3: data.opsiC,
    pilihan_4: data.opsiD,
    pilihan_5: data.opsiE,
    jawaban: data.jawaban,
    pembahasan: data.pembahasan,
    mapel_id: data.mapelId,
    // jenjang_id: data.jenjang,
    // jenis_soal_id: data.jenis,
    // bab_id: data.babId,
    // sub_bab_id: data.subBabId,
    // sub_sub_bab_id: data.subSubBabId,
    // sumber: data.sumber,
    // pembahasan: data.pembahasan,
    // is_restricted: data.is_restricted,
    // label: data.label,
    arr_grades: data.grades
  }

  http.put('/item/' + id, postData, config)
    .then(function (response) {
      callback({
        success: true,
        data: response.data
      })
    }).catch(function (error) {
      callback({
        success: false,
        message: error.message
      })
    })
}

function deleteItem (id, callback) {
  var config = getConfig()
  http.delete('/item/' + id, config)
    .then(function (response) {
      callback({
        success: true,
        data: response.data
      })
    }).catch(function (error) {
      callback({
        success: false,
        message: error.message
      })
    })
}

function getItemById (id, callback) {
  var config = getConfig()
  http.get('/item/' + id, config)
    .then(function (response) {
      callback({
        success: true,
        data: response.data
      })
    }).catch(function (error) {
      callback({
        success: false,
        message: error.message
      })
    })
}

function createWacana (data, callback) {
  var config = getConfig()
  var postData = {
    mapel_id: data.mapelId,
    isi: data.wacana
  }

  http.post('/wacana', postData, config)
    .then(function (response) {
      callback({
        success: true,
        data: response.data
      })
    }).catch(function (error) {
      callback({
        success: false,
        message: error.message
      })
    })
}

function updateWacana (id, data, callback) {
  var config = getConfig()
  var putData = {
    mapel_id: data.mapelId,
    isi: data.wacana
  }

  http.put('/wacana/' + id, putData, config)
    .then(function (response) {
      callback({
        success: true,
        data: null
      })
    }).catch(function (error) {
      callback({
        success: false,
        message: error.message
      })
    })
}

function getListWacana (mapelId, callback) {
  var config = getConfig()
  http.get('/wacanas?mapel_id=' + mapelId, config).then(function (response) {
    callback({
      success: true,
      data: response.data
    })
  }).catch(function (error) {
    callback({
      success: false,
      message: error.message
    })
  })
}

function searchItemByItemCode (itemcode, callback) {
  var config = getConfig()
  http.get('/items?random=false&item_code=' + itemcode, config).then(function (response) {
    callback({
      success: true,
      data: response.data
    })
  }).catch(function (error) {
    callback({
      success: false,
      message: error.message
    })
  })
}

function searchItemByItemCodeAndGrade (itemcode, grade, callback) {
  var config = getConfig()
  var gr = ''
  if(grade) gr = '&grade='+ parseInt(grade)
  http.get('/items?random=false&item_code=' + itemcode + gr, config).then(function (response) {
    callback({
      success: true,
      data: response.data
    })
  }).catch(function (error) {
    callback({
      success: false,
      message: error.message
    })
  })
}

function addBab(data, callback) {
  var config = getConfig()
  http.post('/bab/', data, config).then(function (response) {
     callback({
       success: true,
       data: response.data
     })
  }).catch(function (error) {
    callback({
      success: false,
      message: error.message
    })
  })
}

function updateBab(id, data, callback) {
  var config = getConfig()
  http.put('/bab/'+id, data, config).then(function (response) {
    callback({
      success: true,
      data: response.data
    })
  }).catch(function (error) {
    callback({
      success: false,
      message: error.message
    })
  })
}

function deleteBab(id, callback) {
  var config = getConfig()
  http.delete('/bab/'+id, config).then(function (response) {
    callback({
      success: true,
      data: response.data
    })
  }).catch(function (error) {
    callback({
      success: false,
      message: error.message
    })
  })
}

function addSubBab(data, callback) {
  var config = getConfig()
  http.post('/subbab/', data, config).then(function (response) {
     callback({
       success: true,
       data: response.data
     })
  }).catch(function (error) {
    callback({
      success: false,
      message: error.message
    })
  })
}

function updateSubBab(id, data, callback) {
  var config = getConfig()
  http.put('/subbab/'+id, data, config).then(function (response) {
    callback({
      success: true,
      data: response.data
    })
  }).catch(function (error) {
    callback({
      success: false,
      message: error.message
    })
  })
}

function deleteSubBab(id, callback) {
  var config = getConfig()
  http.delete('/subbab/'+id, config).then(function (response) {
    callback({
      success: true,
      data: response.data
    })
  }).catch(function (error) {
    callback({
      success: false,
      message: error.message
    })
  })
}

function addSubSubBab(data, callback) {
  var config = getConfig()
  http.post('/subsubbab/', data, config).then(function (response) {
     callback({
       success: true,
       data: response.data
     })
  }).catch(function (error) {
    callback({
      success: false,
      message: error.message
    })
  })
}

function updateSubSubBab(id, data, callback) {
  var config = getConfig()
  http.put('/subsubbab/'+id, data, config).then(function (response) {
    callback({
      success: true,
      data: response.data
    })
  }).catch(function (error) {
    callback({
      success: false,
      message: error.message
    })
  })
}

function deleteSubSubBab(id, callback) {
  var config = getConfig()
  http.delete('/subsubbab/'+id, config).then(function (response) {
    callback({
      success: true,
      data: response.data
    })
  }).catch(function (error) {
    callback({
      success: false,
      message: error.message
    })
  })
}

function getTopicMappings(gradeId, interest, callback) {
  var config = getConfig()
  http.get('/topic_mappings?grade_id='+gradeId+"&interest="+interest, config).then(function (response) {
    callback({
      success: true,
      data: response.data
    })
  }).catch(function (error) {
    callback({
      success: false,
      message: error.message
    })
  })
}

function createTopicMapping(mapelId, babId, subBabId, subSubBabId, gradeId, interest, callback) {
  var config = getConfig()
  var data = {
    mapel_id: mapelId,
    bab_id: babId,
    sub_bab_id: subBabId,
    sub_sub_bab_id: subSubBabId,
    grade_id: gradeId,
    interest: interest
  }

  http.post('/topic_mapping', data, config).then(function (response) {
    callback({
      success: true,
      data: response.data
    })
  }).catch(function (error) {
    callback({
      success: false,
      message: error.message
    })
  })
}

function deleteTopicMapping(mapelId, babId, subBabId, subSubBabId, gradeId, interest, callback) {
  var config = getConfig()
  var url = '/topic_mapping?grade_id='+gradeId+'&interest='+interest+'&mapel_id='+mapelId+'&bab_id='+babId
  if (subBabId != null) url += '&sub_bab_id='+subBabId
  if (subSubBabId != null) url += '&sub_sub_bab_id='+subSubBabId

  http.delete(url, config).then(function (response) {
    callback({
      success: true,
      data: response.data
    })
  }).catch(function (error) {
    callback({
      success: false,
      message: error.message
    })
  })
}

function getListModulBelajar(callback)
{
  var config = getConfig()
  http.get('/modules', config).then(function (response) {
    callback({
      success: true,
      data: response.data
    })
  }).catch(function (error) {
    callback({
      success: false,
      data: error.message
    })
  })
}

function getLiveStream (id, callback) {
  var config = getConfig()
  http.get('/streaming/' + id, config).then(function (response) {
    callback({
      success: true,
      data: response.data
    })
  }).catch(function (error) {
    callback({
      success: false,
      message: error.message
    })
  })
}

function createModulBelajar(data, callback) {
  var config = getConfig()
  http.post('/module', data, config).then(function (response) {
    callback({
      success: true,
      data: response.data
    })
  }).catch(function (error) {
    callback({
      success: false,
      message: error.message
    })
  })
}

function updateModulBelajar(id, data, callback) {
  var config = getConfig()
  http.put('/module/' + id, data, config).then(function (response) {
    callback({
      success: true,
      data: response.data
    })
  }).catch(function (error) {
    callback({
      success: false,
      message: error.message
    })
  })
}

function getModulBelajar(id, callback) {
  var config = getConfig()
  http.get('/module/' + id, config).then(function (response) {
    callback({
      success: true,
      data: response.data
    })
  }).catch(function (error) {
    callback({
      success: false,
      data: error.message
    })
  })
}

function deleteModulBelajar(id, callback)
{
  var config = getConfig()
  http.delete('/module/' + id, config).then(function (response) {
    callback({
      success: true,
      data: response.data
    })
  }).catch(function (error) {
    callback({
      success: false,
      message: error.message
    })
  })
}

export default {
  getListMataPelajaran,
  getItemsByMataPelajaran,
  getListOfItemType,
  getListOfSchoolGrade,
  getListOfTopicGrade,
  getListOfTopic,
  createItem,
  updateItem,
  deleteItem,
  getItemById,
  updateWacana,
  createWacana,
  getListWacana,
  searchItemByItemCode,
  addBab,
  updateBab,
  deleteBab,
  addSubBab,
  updateSubBab,
  deleteSubBab,
  addSubSubBab,
  updateSubSubBab,
  deleteSubSubBab,
  getTopicMappings,
  createTopicMapping,
  deleteTopicMapping,
  getListModulBelajar,
  createModulBelajar,
  getModulBelajar,
  updateModulBelajar,
  deleteModulBelajar,
  getLiveStream,
  searchItemByItemCodeAndGrade
}



// WEBPACK FOOTER //
// ./src/services/freeitembank.js